import { restClient } from '../config/restClient'

const endpoint = companyId => `/api/company/profiles/${companyId}`

export const getCompany = async companyId => {
  const response = await restClient(endpoint(companyId), {
    method: 'GET',
  })

  return response.data
}
